import { authRoles } from 'app/auth';
import { FuseLoadable } from '@fuse';

const ScaleReadingsConfig = {
    auth: [...authRoles.admin, ...authRoles.processor, ...authRoles.hauling],
    routes: [{ path: '/list-scale-readings', component: FuseLoadable({ loader: () => import('./list/ListScaleReadingsApp') }) }],
};

export default ScaleReadingsConfig;
